import React, { useState } from 'react';
import { Link } from 'react-router-dom'

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss'

export default function VideoOne() {
  let [isOpen, setOpen] = useState(false);
  return (
    <>
      <div className="position-absolute top-50 start-50 translate-middle">
        <Link to="#" onClick={() => setOpen(true)} className="avatar avatar-md-md rounded-pill shadow card d-flex justify-content-center align-items-center lightbox">
          <i className="mdi mdi-play mdi-24px text-primary"></i>
        </Link>
      </div>
      <ModalVideo
        channel="vimeo"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="1061471069"
        onClose={() => setOpen(false)}
      />
    </>
  )
}
